import { Box, Typography } from '@mui/material';

export const Legenda = () => {
  const items = [
    { color: 'primary.infoRow', label: 'Observações' },
    { color: '#cfcff0', label: 'Clicheria' },
    { color: 'secondary.light', label: 'Vinculada' },
    { color: '#C7FFED', label: '+ Caixas' },
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1 }}>
      {/* Coluna esquerda */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {items.slice(0, 2).map(({ color, label }) => (
          <Box
            key={label}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              width: 110,
              justifyContent: 'center',
              bgcolor: color,
              gap: 1,
            }}
          >
            <Typography variant="caption" textAlign="center">
              {label}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* Coluna direita */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {items.slice(2, 4).map(({ color, label }) => (
          <Box
            key={label}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              width: 110,
              justifyContent: 'center',
              bgcolor: color,
              gap: 1,
            }}
          >
            <Typography variant="caption" textAlign="center">
              {label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
